import { render, staticRenderFns } from "./ModuleSlideIntro.vue?vue&type=template&id=7360cd3b&scoped=true&"
import script from "./ModuleSlideIntro.vue?vue&type=script&lang=js&"
export * from "./ModuleSlideIntro.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSlideIntro.vue?vue&type=style&index=0&id=7360cd3b&lang=scss&"
import style1 from "./ModuleSlideIntro.vue?vue&type=style&index=1&id=7360cd3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360cd3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7360cd3b')) {
      api.createRecord('7360cd3b', component.options)
    } else {
      api.reload('7360cd3b', component.options)
    }
    module.hot.accept("./ModuleSlideIntro.vue?vue&type=template&id=7360cd3b&scoped=true&", function () {
      api.rerender('7360cd3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/ModuleSlideIntro.vue"
export default component.exports